import AuthService from './auth'
import DashboardService from './dashboard'

export default {
    auth: AuthService(),
    dashboard: DashboardService()
}